import Prepration from "./Prepration";
export default Prepration;
